import { render, staticRenderFns } from "./RegionStatistics.vue?vue&type=template&id=7d1e3874&scoped=true&"
import script from "./RegionStatistics.vue?vue&type=script&lang=ts&"
export * from "./RegionStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./RegionStatistics.vue?vue&type=style&index=0&id=7d1e3874&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1e3874",
  null
  
)

export default component.exports